module.exports = __webpack_public_path__ + "static/media/animal-dog7.f45e10fe.aac";